import styled from "styled-components";
import theme from "../../../../styles/theme";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.brown.capivara};
`;

export const LoginBox = styled.div`
  max-width: 400px;
  background-color: ${theme.colors.brown.capivaraLightAux};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

export const DivComponentEmail = styled.div`
  color: black;
  p {
    text-align: center;
    margin-bottom: 25px;
    font-family: sans-serif;
  }

  svg {
    color: red;
  }

  div {
    margin-top: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  span {
    margin-left: 5px;
    color: red;
  }
`;

export const Logo = styled.div`
  display: flex;
  height: 600px !important;
  justify-content: center;
  align-items: center;

  img {
    max-width: 250px;
    height: auto;
  }
`;

export const RadioContainer = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 5px;

  label {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const FormSignUp = styled.form`
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 10px;

  div {
    width: 100%;
  }
`;
